import { HORIZONTAL, A } from '../ds/components/logoGeometria.js';
import baldosa from '../ds/tramas/neg-orquidea.svg';

// La tarjeta para compartir: 1080×1350 (4:5, formato de Instagram y de estado de WhatsApp).
// Se comparte el resultado de la persona, no GUIA: la frase de alguien que abrió camino en lo que ella empieza,
// su rumbo en chico y el logo de firma. Fondo: negativo Orquídea a escala grande; el texto, en panel blanco.
// No lleva nada escrito por la persona.
const ORQUIDEA = '#9B1FB0';
const CIRUELA = '#3B1043';
const NEGRO = '#0A0A0A';
const BLANCO = '#FFFFFF';
const TILE = 270; // 4 baldosas de ancho exactas: las A salen grandes, no un mantel
const DISPLAY = '"Averia Sans Libre", system-ui, sans-serif';
const SUB = '"Montserrat Alternates", system-ui, sans-serif';
const CUERPO = 'Harmattan, system-ui, sans-serif';

const cargarImagen = (src) => new Promise((ok, no) => { const i = new Image(); i.onload = () => ok(i); i.onerror = no; i.src = src; });
const conTope = (p, ms) => Promise.race([p, new Promise((ok) => setTimeout(ok, ms))]);

// Parte `txt` en líneas que entren en `ancho`.
const lineas = (ctx, txt, ancho) => {
  const out = []; let linea = '';
  for (const palabra of txt.split(' ')) {
    const prueba = linea ? `${linea} ${palabra}` : palabra;
    if (ctx.measureText(prueba).width > ancho && linea) { out.push(linea); linea = palabra; } else linea = prueba;
  }
  if (linea) out.push(linea);
  return out;
};

// El logo real (GU negro + IA Orquídea, con la A como aguja), dibujado con la geometría de logoGeometria.
const dibujarLogo = (ctx, xCentro, yTop, ancho) => {
  const [, , vw, vh] = HORIZONTAL.viewBox.split(' ').map(Number);
  const [vx, vy] = HORIZONTAL.viewBox.split(' ').map(Number);
  const k = ancho / vw;
  ctx.save();
  ctx.translate(xCentro - ancho / 2 - vx * k, yTop - vy * k);
  ctx.scale(k, k);
  for (const l of HORIZONTAL.letras) {
    const m = /translate\(([-\d.]+)[ ,]+([-\d.]+)\)/.exec(l.transform || '');
    ctx.save();
    if (m) ctx.translate(Number(m[1]), Number(m[2]));
    ctx.fillStyle = l.gu ? NEGRO : ORQUIDEA;
    ctx.fill(new Path2D(l.d));
    ctx.restore();
  }
  ctx.save();
  ctx.transform(...HORIZONTAL.a);
  ctx.fillStyle = ORQUIDEA;
  ctx.fill(new Path2D(A), 'evenodd');
  ctx.restore();
  ctx.restore();
  return (vh * k);
};

// `rotulo`: el texto de la cápsula de arriba («Mi rumbo: Web»). Sin él, la tarjeta lleva solo la frase.
export async function generarTarjeta({ rotulo, frase }) {
  try {
    await conTope(Promise.all([
      document.fonts.load(`700 64px ${DISPLAY}`),
      document.fonts.load(`italic 600 32px ${SUB}`),
      document.fonts.load(`500 32px ${CUERPO}`),
    ]), 3000);
  } catch { /* sin fuentes de marca: cae a la del sistema */ }

  const W = 1080, H = 1350;
  const canvas = document.createElement('canvas');
  canvas.width = W; canvas.height = H;
  const ctx = canvas.getContext('2d');

  // trama a escala grande
  const tile = await cargarImagen(baldosa);
  const celda = document.createElement('canvas');
  celda.width = TILE; celda.height = TILE;
  celda.getContext('2d').drawImage(tile, 0, 0, TILE, TILE);
  ctx.fillStyle = ctx.createPattern(celda, 'repeat');
  ctx.fillRect(0, 0, W, H);

  // panel blanco
  const px = 90, py = 90, pw = 900, ph = 1170;
  ctx.fillStyle = BLANCO;
  ctx.beginPath(); ctx.roundRect(px, py, pw, ph, 72); ctx.fill();
  ctx.textBaseline = 'alphabetic';

  // el rumbo, en chico
  if (rotulo) {
    ctx.font = `italic 600 34px ${SUB}`;
    const rw = ctx.measureText(rotulo).width + 64;
    ctx.fillStyle = ORQUIDEA;
    ctx.beginPath(); ctx.roundRect(W / 2 - rw / 2, 160, rw, 64, 32); ctx.fill();
    ctx.fillStyle = BLANCO; ctx.textAlign = 'center';
    ctx.fillText(rotulo, W / 2, 203);
  }

  // comillas grandes
  ctx.font = `700 260px ${DISPLAY}`; ctx.fillStyle = ORQUIDEA; ctx.textAlign = 'left';
  ctx.fillText('“', 150, 470);

  // la frase: la letra más grande que entre
  const caja = { x: 150, ancho: 780, top: 420, alto: 470 };
  let tam = 112, ls = [];
  for (; tam >= 44; tam -= 4) {
    ctx.font = `700 ${tam}px ${DISPLAY}`;
    ls = lineas(ctx, frase.texto, caja.ancho);
    if (ls.length * tam * 1.08 <= caja.alto) break;
  }
  ctx.fillStyle = CIRUELA; ctx.textAlign = 'left';
  const alto = ls.length * tam * 1.08;
  let y = caja.top + (caja.alto - alto) / 2 + tam * 0.86;
  for (const l of ls) { ctx.fillText(l, caja.x, y); y += tam * 1.08; }

  // autor
  ctx.font = `italic 600 44px ${SUB}`; ctx.fillStyle = ORQUIDEA;
  ctx.fillText(frase.autor, caja.x, 960);
  ctx.font = `500 34px ${CUERPO}`; ctx.fillStyle = CIRUELA;
  ctx.fillText(frase.rol, caja.x, 1010);

  // firma: el logo de GUIA
  ctx.fillStyle = CIRUELA;
  ctx.fillRect(caja.x, 1070, 780, 3);
  dibujarLogo(ctx, W / 2, 1105, 230);

  const blob = await new Promise((ok) => canvas.toBlob(ok, 'image/png'));
  return { blob, url: canvas.toDataURL('image/png') };
}
